import React, { useState } from 'react';
import { TOP_INDENTS } from '@constants';
import { useStore } from '@hooks';
import { Input, Select } from '@ui';
import { Form } from 'antd';
import modalOptions from '../../options';
import { CancelSubmit } from '../CancelSubmit';

const FeedbackModalContent = ({ close, type = 'campaign-paused', onSuccess }) => {
    const store = useStore();
    const { submitFeedback } = store.accountsStore;
    const [formSubmitting, setFormSubmitting] = useState(false);
    const typeModalOptions = modalOptions[type];

    const [form] = Form.useForm();
    const selectedReason = Form.useWatch('reason', form);

    const onSubmit = async (values) => {
        setFormSubmitting(true);

        try {
            // Only send feedback if a reason was selected
            if (values.reason) {
                await submitFeedback(type, values.reason, values.details);
            }
        } catch (error) {
            // nothing here
        } finally {
            if (onSuccess) {
                onSuccess();
            }

            setFormSubmitting(false);
            close();
        }
    };

    return (
        <React.Fragment>
            <Form form={form} onFinish={onSubmit}>
                <Form.Item name='reason'>
                    <Select
                        label='Please select a reason'
                        optionFilterProp='label'
                        showSearch
                        options={typeModalOptions?.reasons?.map(({ label }) => ({ label, value: label }))}
                    />
                </Form.Item>
                {selectedReason === 'Other' && (
                    <Form.Item name='details' style={TOP_INDENTS.S}>
                        <Input.TextArea label='Please share additional details' rows={4} />
                    </Form.Item>
                )}
                <CancelSubmit
                    onCancel={close}
                    loading={formSubmitting}
                    style={TOP_INDENTS.XL_PLUS}
                    cancelText={typeModalOptions?.cancelButtonText}
                    submitText={typeModalOptions?.submitButtonText}
                />
            </Form>
        </React.Fragment>
    );
};

export default FeedbackModalContent;
